import React, { memo } from "react";
import SectionSvg from "../assets/svg/SectionSvg";
import clsx from "clsx"; // Utility to conditionally join class names

const Section = ({
  className,
  id,
  crosses,
  crossesOffset,
  customPaddings,
  children,
}) => {
  const sectionClassNames = clsx(
    "relative",
    customPaddings || "py-10 lg:py-16 xl:py-20",
    crosses && "lg:py-32 xl:py-40", // Apply this class only if crosses exists
    className,
  );

  return (
    <div id={id} className={sectionClassNames}>
      {children}

      <div className="pointer-events-none absolute left-5 top-0 hidden h-full w-0.25 bg-stroke-1 md:block lg:left-7.5 xl:left-10" />
      <div className="pointer-events-none absolute right-5 top-0 hidden h-full w-0.25 bg-stroke-1 md:block lg:right-7.5 xl:right-10" />

      {crosses && (
        <>
          <div
            className={clsx(
              "pointer-events-none absolute left-7.5 right-7.5 top-0 hidden h-0.25 bg-stroke-1 lg:block xl:left-10",
              crossesOffset && crossesOffset,
            )}
          />
          <React.Suspense fallback={null}>
            <SectionSvg crossesOffset={crossesOffset} />
          </React.Suspense>
        </>
      )}
    </div>
  );
};

// Memoize the Section component while preserving its name for Fast Refresh
const MemoizedSection = memo(Section);
MemoizedSection.displayName = "Section"; // Ensures the display name for debugging

export default MemoizedSection;
